import React from 'react';
import './Headers.css'
import Particles from "react-tsparticles";
import { Typewriter } from 'react-simple-typewriter'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faGithub,faFacebook,faLinkedin,faInstagram } from '@fortawesome/free-brands-svg-icons'
import img from '../../../images/profile_n.jpg'
import { Container } from 'react-bootstrap';
import Navigation from '../Navigation/Navigation';


const Headers = () => {
    const particlesInit = (main) => {
        console.log(main);
    
        // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
      };
    
      const particlesLoaded = (container) => {
        console.log(container);
      };

      // react Typewriter 
    return (
        
        <div className='bg-img'>
             <Container>
                 <Navigation></Navigation>
                
                <div className='row my-5'>
                
                <div className='col-md-10'>
                <div className='row'>
                <div className='col-md-4 img-fluid' >
                <img className='img-fluid profilePic' src={img} alt=''/>
                </div>
                <div className='col-md-8 my-bio'>
                <h1 className='name font'>Md Arman Hossain</h1>
                <h2 className='font'> I'm A 
                <span>
                  <Typewriter
                  loop
                  cursor
                  cursorStyle='_'
                  typeSpeed={250}
                  delaySpeed={1000}
                  delaySpeed={1500}
                  words={[' Front-End Developer',' React Developer']}
                  />
                </span>
                 </h2>
                 <div className='personal-contract  '>
                 <dl>
               <dt>AGE</dt>
               <dd>21</dd>
               <dt>EMAIL</dt>
               <dd >armanh20439@gmail.com
               </dd>
               <dt>PHONE</dt>
               <dd>+88018-54887095</dd>
             
               <dt>ADDRESS</dt>
               <dd>CHANDPUR BANGLADESH</dd>
               </dl>
                     </div>
{/* resume button  */}
            <a data-aos="zoom-in" data-aos-anchor-placement="center-bottom"
            data-aos-duration="2000" rel="noreferrer"  
            className='resume btn' 
            href='https://drive.google.com/file/d/1IgzytFjRurTsO2nY75qPhaqRQdQ71kxD/view?usp=sharing' 
            target='_blank'>Download Resume</a>
            </div>
            </div>
            </div>
            <div className='col-md-2 '>
            <div className='links'>
            <div className="links-inner" data-aos="fade-up"
     data-aos-anchor-placement="center-bottom"
     data-aos-duration="500">
                      <a 
          className="mb-3"
          rel="noreferrer" 
          href='https://www.facebook.com/mdarman.hossain.710667/' 
          target='_blank'
          ><FontAwesomeIcon className='social-icons' icon={faFacebook}></FontAwesomeIcon></a>
          <a 
           className="mb-3"
          rel="noreferrer" 
          href='https://github.com/armanh20439' 
          target='_blank'
          ><FontAwesomeIcon className='social-icons' icon={faGithub}></FontAwesomeIcon></a>
          <a 
           className="mb-3"
          rel="noreferrer" 
          href='https://www.linkedin.com/in/md-arman-hossain-01aa69226/' target='_blank'
          ><FontAwesomeIcon className='social-icons' icon={faLinkedin}></FontAwesomeIcon></a>
          <a 
          rel="noreferrer" 
          href='https://www.instagram.com/ar_man_hossain_kb/' 
          target='_blank' 
          ><FontAwesomeIcon className='social-icons' icon={faInstagram}></FontAwesomeIcon></a> 
                      </div>
           </div>
                    </div>
                 
                  
                   
                </div>
                </Container>
           <div> <Particles
      id="tsparticles"
      init={particlesInit}
      loaded={particlesLoaded}
      options={{
       
        fpsLimit: 60,
        interactivity: {
          events: {
            onClick: {
              enable: true,
              mode: "push",
            },
            onHover: {
              enable: true,
              mode: "repulse",
            },
            resize: true,
          },
          modes: {
            bubble: {
              distance: 400,
              duration: 2,
              opacity: 0.8,
              size: 40,
            },
            push: {
              quantity: 4,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
          },
        },
        particles: {
          color: {
            value: "#ffffff",
          },
          links: {
            color: "#ffffff",
            distance: 150,
            enable: true,
            opacity: 0.5,
            width: 1,
          },
          collisions: {
            enable: true,
          },
          move: {
            direction: "none",
            enable: true,
            outMode: "bounce",
            random: false,
            speed: .5,
            straight: false,
          },
          number: {
            density: {
              enable: true,
              value_area: 800,
            },
            value: 60,
          },
          opacity: {
            value: 0.5,
          },
          shape: {
            type: "circle",
          },
          size: {
            random: true,
            value: 7,
          },
        },
        detectRetina: true,
      }}
    /></div>
           
           
        </div>
        
    );
};

export default Headers;